import React, { useState } from 'react';
import Img from '../../common/Img';
import ButtonsScroller from '../../common/ButtonsScroller';
import { classIf } from '../../data/utils';
import EventStats from '../../common/EventStats';
import LiveTrackerToggle from '../../common/live-tracker/LiveTrackerToggle';
import { usePrematchData } from '.././PrematchDataFetcher';
import Bets from './Bets';
import FavoriteMarketsProvider from '../../common/favorite-markets/FavoriteMarkets';
import FavoriteMarkets from './FavoriteMarkets';
import EventFetcher from './EventFetcher';
import LiveStandings from '../../common/standings/LiveStandings';
import PrematchStandings from '../../common/standings/PrematchStandings';
import FavoritesButton from '../../common/favorite-markets/FavoritesButton';
import { navigate } from '../../router/Link';
import { getTournamentUrl } from '../Prematch';
import FavoriteEventToggle from '../../common/favorite-events/FavoriteEventToggle';
import { getUniqueId } from '../Tournament';
import { getLabel } from '../../InitData';

export default function Event(props) {
    const prematchData = usePrematchData();
    const eventData = props.data;
    const [section, setSection] = useState('bets');
    const [macroId, setMacroId] = useState(-1 * eventData.sportRef);
    const showFavorites = section === 'favorites';

    const sport = prematchData.sportById[eventData.sportRef];
    const category = sport.categoryById[eventData.categoryRef];

    function changeMacro(macroId) {
        setSection('bets');
        setMacroId(macroId);
    }

    function closeEvent() {
        const t = category.tournamentById[eventData.tournamentRef];
        navigate(getTournamentUrl(t));
    }

    return (
        <FavoriteMarketsProvider>
            <div className="c_17">
                <div className="c_17_1">
                    <div className="c_18">
                        <div className="c_18_1">
                            <span className="c_18_1_1">{eventData.alias}</span>
                            <span className="c_18_1_2">{category.descrizione} | {eventData.tournamentDesc}</span>
                            <div className="c_18_1_4"></div>
                            <div className="c_18_1_3">
                                <FavoriteEventToggle className="c_18_1_3_1" id={getUniqueId(eventData)} />
                                <LiveTrackerToggle data={eventData} />
                                <Img className="c_18_1_3_1" src="icon_close.svg" height="32px" width="32px" onClick={closeEvent} />
                            </div>
                        </div>
                        <div className="c_18_2">
                            <div className="c_18_2_1">
                                <div className="c_18_2_1_1">{eventData.dateShort}</div>
                                <div className="c_18_2_1_2">{eventData.team1}</div>
                            </div>
                            <div className="c_18_2_1">
                                <div className="c_18_2_1_1">{eventData.time}</div>
                                <div className="c_18_2_1_2">{eventData.team2}</div>
                            </div>
                        </div>
                    </div>
                    <div className="c_19">
                        <div className={"c_19_1" + classIf(showFavorites || section === 'bets', 'active')} onClick={() => setSection('bets')}>{getLabel('event.navbar.odds')}</div>
                        <div className={"c_19_1" + classIf(section === 'stats', 'active')} onClick={() => setSection('stats')}>{getLabel('event.navbar.stats')}</div>
                        {/* <div className={"c_19_1" + classIf(section === 'h2h', 'active')} onClick={() => setSection('h2h')}>{getLabel('event.navbar.h2h)}</div> */}
                        <div className={"c_19_1" + classIf(section === 'teams', 'active')} onClick={() => setSection('teams')}>{getLabel('event.navbar.teams')}</div>
                    </div>
                    <ButtonsScroller>
                        {eventData.macrogruppi?.map((m, i) =>
                            <React.Fragment key={m.id}>
                                {i === 1 &&
                                    <>
                                        {/* <div className="c_20_2_1">{getLabel('betbuilder.title')}</div> */}
                                        <FavoritesButton className={"c_20_2_1" + classIf(showFavorites, 'active')} onClick={() => setSection('favorites')} />
                                    </>
                                }
                                <div className={"c_20_2_1" + classIf(!showFavorites && macroId === m.id, 'active')} onClick={() => changeMacro(m.id)}>{m.descrizione}</div>
                            </React.Fragment>
                        )}
                    </ButtonsScroller>
                </div>
                {(function() {
                    switch (section) {
                        default:
                        case 'odds':
                            return (
                                <div className="c_17_2">
                                    <EventFetcher macroId={macroId} data={eventData} renderItem={(data) =>
                                        <Bets bets={data.bets} team1={eventData.team1} team2={eventData.team2} />
                                    } />
                                </div>
                            );
                        case 'favorites':
                            return <FavoriteMarkets event={eventData} />;
                        case 'stats':
                            return <EventStats data={eventData} />;
                        case 'h2h':
                            return null;
                        case 'teams': {
                            return (
                                <>
                                    {eventData.isLive ?
                                        <LiveStandings data={eventData} />
                                        :
                                        <PrematchStandings data={eventData} />
                                    }
                                </>
                            );
                        }
                    }
                })()}
            </div>
        </FavoriteMarketsProvider>
    );
}
